import { WebEdiConfiguration, WebEdiIntegrationSettings } from './webEdiApiTypes';

// eslint-disable-next-line import/prefer-default-export
export const mockGetWebEdiConfigurations: WebEdiConfiguration[] = [
  {
    gln: '123456789',
  },
  {
    gln: '111222333',
  },
];

export const mockGetWebEdiIntegrationSettingsResponse: WebEdiIntegrationSettings = {
  partnerReceiverGln: 'GLN123456789',
  partnerSupplierGln: 'GLN123456799',
  configuredGln: '111222333',
};
